import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent {
  submit = false;
  isSubmitted = false;
  myFormSubmit = false;
  isSuccess: any = false

  constructor(private fb: FormBuilder, private router: Router, public apiService: ApiServiceService, public shared: SharedService) {
    this.shared.isWhiteMenu = true
   }

  forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  async onSubmit() {
    this.myFormSubmit = true;
    console.log(this.forgotPasswordForm.value)
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FORGOT_PASSWORD,
      this.forgotPasswordForm.value
    );
    console.log("res", res);
    if (res && !res.error) {
      this.isSubmitted = true;
      this.isSuccess = true
    }
  }
}
